module.exports = __webpack_public_path__ + "static/media/HealthyLungs – 1.eeee37e5.jpg";